'use client';

import { useTheme } from 'next-themes';
import { hotpadsDarkStyle, type MapStyle } from '@/src/components/features/search/Map/mapStyles';

/**
 * Styles for a `google.maps.Map` built without a cloud map id, so it follows the device's
 * color mode: HotPads' dark style in dark mode, Google's default (null) in light mode.
 * Apply with `map.setOptions({ styles })`, which also restyles an open map when the mode changes.
 */
export function useDarkMapStyles(): MapStyle | null {
  const { resolvedTheme } = useTheme();
  return resolvedTheme === 'dark' ? hotpadsDarkStyle : null;
}
